import Authenticated from "src/components/Authenticated";
import BaseLayout from "src/layouts/BaseLayout";

//Routes and Elements
import baseRoutes from "./base";
import { Users } from "src/pages/Users";
import AccentHeaderLayout from "src/layouts/AccentHeaderLayout";
import BottomNavigationLayout from "src/layouts/BottomNavigationLayout";
import AccentSidebarLayout from "src/layouts/AccentSidebarLayout";
import BoxedSidebarLayout from "src/layouts/BoxedSidebarLayout";
import CollapsedSidebarLayout from "src/layouts/CollapsedSidebarLayout";
import ExtendedSidebarLayout from "src/layouts/ExtendedSidebarLayout";
import TopNavigationLayout from "src/layouts/TopNavigationLayout";
import Dashboard from "src/pages/Dashboard";
import MyAccount from "src/pages/MyAccount";
import { Roles } from "src/pages/Roles";
import { InvoiceExpeditors } from "src/pages/InvoiceExpeditors";
import { InvoicerXmlToPdf } from "src/pages/InvoicerXmlToPdf";
import { InvoicerXmlToList } from "src/pages/InvoicerXmlToList";
import { Clients } from "src/pages/Clients";
import { GenericInvoiceCatalogs } from "src/pages/GenericInvoiceCatalogs";
import { InvoiceClientConfigs } from "src/pages/InvoiceClientConfigs";
import { InvoiceCombineKeys } from "src/pages/InvoiceCombineKeys";
import { createBrowserRouter, Navigate } from "react-router-dom";
import App from "src/App";

let layout = <ExtendedSidebarLayout />;
switch (localStorage.getItem("layout")) {
  case "EXTENDED_SIDEBAR":
    layout = <ExtendedSidebarLayout />;
    break;
  case "ACCENT_HEADER":
    layout = <AccentHeaderLayout />;
    break;
  case "ACCENT_SIDEBAR":
    layout = <AccentSidebarLayout />;
    break;
  case "BOXED_SIDEBAR":
    layout = <BoxedSidebarLayout />;
    break;
  case "COLLAPSED_SIDEBAR":
    layout = <CollapsedSidebarLayout />;
    break;
  case "BOTTOM_NAVIGATION":
    layout = <BottomNavigationLayout />;
    break;
  case "TOP_NAVIGATION":
    layout = <TopNavigationLayout />;
    break;
  default:
    layout = <BoxedSidebarLayout />;
    break;
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "",
        element: <BaseLayout />,
        children: baseRoutes
      },
      {
        path: "admin",
        element: <Authenticated>{layout}</Authenticated>,
        children: [
          {
            path: "",
            element: <Navigate to="dashboard" replace />,
          },
          {
            path: "dashboard",
            element: <Dashboard />
          },
          {
            path: 'invoicer-xml-to-pdf',
            element: <InvoicerXmlToPdf />
          },
          {
            path: 'invoicer-xml-to-list',
            element: <InvoicerXmlToList />
          },
          {
            path: 'invoice-expeditors',
            element: <InvoiceExpeditors />
          },
          {
            path: 'clients',
            element: <Clients />
          },
          {
            path: 'invoice-client-configs',
            element: <InvoiceClientConfigs />
          },
          {
            path: 'invoice-combine-keys',
            element: <InvoiceCombineKeys />
          },
          {
            path: 'invoice-catalogs',
            element: <GenericInvoiceCatalogs />
          },
          {
            path: 'roles',
            element: <Roles />
          },
          {
            path: "users",
            element: <Users />
          },
          {
            path: 'my-account',
            element: <MyAccount />
          }
        ],
      },
    ]
  },
]);

export default router;
